<router-outlet></router-outlet>

<!-- Toast notifications - should be at the end -->
<app-toast></app-toast>
